export const CUSTOMERS = 'CUSTOMERS'
export const CUSTOMERS_CHARTS = 'CUSTOMERS_CHARTS'
export const METRICS = 'METRICS'
export const METRIC_TIMELINE = 'METRIC_TIMELINE'
// export const CREATE_CONTRACT = 'CREATE_CONTRACT'
export const RECALCULATE_METRICS = 'RECALCULATE_METRICS'
export const REALLOCATE_CUSTOMER = 'REALLOCATE_CUSTOMER'

export const CUSTOMER = 'CUSTOMER'
export const CUSTOMER_PROPERTY_HISTORY_TIMELINE = 'CUSTOMER_PROPERTY_HISTORY_TIMELINE'
export const CUSTOMER_PROPERTY_UPDATE = 'CUSTOMER_PROPERTY_UPDATE'
export const CUSTOMER_METRICS = 'CUSTOMER_METRICS'
export const CUSTOMER_METRIC_TIMELINE = 'CUSTOMER_METRIC_TIMELINE'
// export const CUSTOMER_CANCELLATIONS = 'CUSTOMER_CANCELLATIONS'
export const CUSTOMER_CONTACTS = 'CUSTOMER_CONTACTS'
export const CUSTOMER_SUBACCOUNTS = 'CUSTOMER_SUBACCOUNTS'
export const CUSTOMER_SUBACCOUNT = 'CUSTOMER_SUBACCOUNT'
export const CUSTOMER_SUBACCOUNT_SEND_INVITE = 'CUSTOMER_SUBACCOUNT_SEND_INVITE'
export const CUSTOMER_SUBACCOUNT_INVITE_USER = 'CUSTOMER_SUBACCOUNT_INVITE_USER'
export const CUSTOMER_SUBACCOUNT_INVITE_LEGACY = 'CUSTOMER_SUBACCOUNT_INVITE_LEGACY'
export const CUSTOMER_SUBACCOUNT_REVOKE_INVITE = 'CUSTOMER_SUBACCOUNT_REVOKE_INVITE'
export const CUSTOMER_SUBACCOUNT_DEACTIVATE_USER = 'CUSTOMER_SUBACCOUNT_DEACTIVATE_USER'
export const CUSTOMER_SUBACCOUNT_DELETE_USER = 'CUSTOMER_SUBACCOUNT_DELETE_USER'
export const CUSTOMER_SUBACCOUNT_FORCE_PASSWORD = 'CUSTOMER_SUBACCOUNT_FORCE_PASSWORD'
export const CUSTOMER_SUBACCOUNT_RESET_PASSWORD = 'CUSTOMER_SUBACCOUNT_RESET_PASSWORD'
export const CUSTOMER_SUBACCOUNT_REMOVE_2FA = 'CUSTOMER_SUBACCOUNT_REMOVE_2FA'
export const CUSTOMER_SUBACCOUNT_LOGS = 'CUSTOMER_SUBACCOUNT_LOGS'
export const CUSTOMER_CONTACT_INVITE_USER = 'CUSTOMER_CONTACT_INVITE_USER'
export const CUSTOMER_CONTACT_INVITE_LEGACY = 'CUSTOMER_CONTACT_INVITE_LEGACY'
export const CUSTOMER_CONTACT_SEND_INVITE = 'CUSTOMER_CONTACT_SEND_INVITE'
export const CUSTOMER_CONTACT_REVOKE_INVITE = 'CUSTOMER_CONTACT_REVOKE_INVITE'
export const CUSTOMER_CONTACT_DEACTIVATE_USER = 'CUSTOMER_CONTACT_DEACTIVATE_USER'
export const CUSTOMER_CONTACT_DELETE_USER = 'CUSTOMER_CONTACT_DELETE_USER'
export const CUSTOMER_CONTACT_FORCE_PASSWORD = 'CUSTOMER_CONTACT_FORCE_PASSWORD'
export const CUSTOMER_CONTACT_RESET_PASSWORD = 'CUSTOMER_CONTACT_RESET_PASSWORD'
export const CUSTOMER_CONTACT_REMOVE_2FA = 'CUSTOMER_CONTACT_REMOVE_2FA'
export const CUSTOMER_CONTACT_LOGS = 'CUSTOMER_CONTACT_LOGS'
// export const CUSTOMER_CONTRACTS = 'CUSTOMER_CONTRACTS'
// export const CUSTOMER_INVOICES = 'CUSTOMER_INVOICES'
export const CUSTOMER_PRODUCTS = 'CUSTOMER_PRODUCTS'
export const CUSTOMER_TOOLBOX_PRODUCTS = 'CUSTOMER_TOOLBOX_PRODUCTS'
export const CUSTOMER_SERVICES = 'CUSTOMER_SERVICES'
export const CUSTOMER_ENABLE_SERVICE = 'CUSTOMER_ENABLE_SERVICE'
export const CUSTOMER_DISABLE_SERVICE = 'CUSTOMER_DISABLE_SERVICE'
export const CUSTOMER_BUNDLES = 'CUSTOMER_BUNDLES'
export const CUSTOMER_BUNDLES_CREATE = 'CUSTOMER_BUNDLES_CREATE'
export const CUSTOMER_BUNDLE_NUMBERS = 'CUSTOMER_BUNDLE_NUMBERS'
export const CUSTOMER_BUNDLE_UPDATE = 'CUSTOMER_BUNDLE_UPDATE'
export const CUSTOMER_TARIFFS = 'CUSTOMER_TARIFFS'
export const CUSTOMER_TARIFF_NUMBERS = 'CUSTOMER_TARIFF_NUMBERS'
export const CUSTOMER_TARIFF_LEGS = 'CUSTOMER_TARIFF_LEGS'
export const CUSTOMER_USER_LOGS = 'CUSTOMER_USER_LOGS'
export const CUSTOMER_USER_LOG = 'CUSTOMER_USER_LOG'
export const CUSTOMER_ACTIVITIES = 'CUSTOMER_ACTIVITIES'
export const CUSTOMER_ACTIVITY = 'CUSTOMER_ACTIVITY'
export const CUSTOMER_STAFF_LOG = 'CUSTOMER_STAFF_LOG'

// Number
export const CUSTOMER_NUMBERS = 'CUSTOMER_NUMBERS'
export const CUSTOMER_NUMBERS_PRODUCTS = 'CUSTOMER_NUMBERS_PRODUCTS'
export const CUSTOMER_NUMBER = 'CUSTOMER_NUMBER'
export const CUSTOMER_NUMBER_CHANGE_OWNERSHIP = 'CUSTOMER_NUMBER_CHANGE_OWNERSHIP'
export const CUSTOMER_NUMBER_SERVICE = 'CUSTOMER_NUMBER_SERVICE'
export const CUSTOMER_NUMBER_PRODUCTS = 'CUSTOMER_NUMBER_PRODUCTS'
export const CUSTOMER_NUMBER_REVISIONS = 'CUSTOMER_NUMBER_REVISIONS'
export const CUSTOMER_NUMBER_REVISION = 'CUSTOMER_NUMBER_REVISION'
export const CUSTOMER_NUMBER_BARRING = 'CUSTOMER_NUMBER_BARRING'
export const CUSTOMER_NUMBER_CREATE_BARRING = 'CUSTOMER_NUMBER_CREATE_BARRING'
export const CUSTOMER_NUMBER_REMOVE_BARRING = 'CUSTOMER_NUMBER_REMOVE_BARRING'
export const CUSTOMER_NUMBER_TECHNOLOGIES = 'CUSTOMER_NUMBER_TECHNOLOGIES'
export const CUSTOMER_NUMBER_BILLING = 'CUSTOMER_NUMBER_BILLING'
export const CUSTOMER_NUMBER_BILLING_UPDATE = 'CUSTOMER_NUMBER_BILLING_UPDATE'
export const CUSTOMER_NUMBER_BILLING_REMOVE = 'CUSTOMER_NUMBER_BILLING_REMOVE'

// Mfa
// export const CUSTOMER_MFA_LIST = 'CUSTOMER_MFA_LIST'
// export const CUSTOMER_CREATE_MFA = 'CUSTOMER_CREATE_MFA'
// export const CUSTOMER_REMOVE_MFA = 'CUSTOMER_REMOVE_MFA'

export default {
    CUSTOMERS,
    CUSTOMERS_CHARTS,
    METRICS,
    METRIC_TIMELINE,
    // CREATE_CONTRACT,
    CUSTOMER,
    CUSTOMER_PROPERTY_HISTORY_TIMELINE,
    CUSTOMER_PROPERTY_UPDATE,
    CUSTOMER_METRICS,
    CUSTOMER_METRIC_TIMELINE,
    // CUSTOMER_CANCELLATIONS,
    CUSTOMER_CONTACTS,
    CUSTOMER_SUBACCOUNTS,
    CUSTOMER_SUBACCOUNT,
    CUSTOMER_SUBACCOUNT_SEND_INVITE,
    CUSTOMER_SUBACCOUNT_INVITE_USER,
    CUSTOMER_SUBACCOUNT_INVITE_LEGACY,
    CUSTOMER_SUBACCOUNT_REVOKE_INVITE,
    CUSTOMER_SUBACCOUNT_DEACTIVATE_USER,
    CUSTOMER_SUBACCOUNT_DELETE_USER,
    CUSTOMER_SUBACCOUNT_FORCE_PASSWORD,
    CUSTOMER_SUBACCOUNT_RESET_PASSWORD,
    CUSTOMER_SUBACCOUNT_REMOVE_2FA,
    CUSTOMER_SUBACCOUNT_LOGS,
    CUSTOMER_CONTACT_INVITE_USER,
    CUSTOMER_CONTACT_INVITE_LEGACY,
    CUSTOMER_CONTACT_SEND_INVITE,
    CUSTOMER_CONTACT_REVOKE_INVITE,
    CUSTOMER_CONTACT_DEACTIVATE_USER,
    CUSTOMER_CONTACT_DELETE_USER,
    CUSTOMER_CONTACT_FORCE_PASSWORD,
    CUSTOMER_CONTACT_RESET_PASSWORD,
    CUSTOMER_CONTACT_REMOVE_2FA,
    CUSTOMER_CONTACT_LOGS,
    // CUSTOMER_CONTRACTS,
    // CUSTOMER_INVOICES,
    CUSTOMER_PRODUCTS,
    CUSTOMER_STAFF_LOG,
    CUSTOMER_NUMBERS,
    CUSTOMER_NUMBER,
    CUSTOMER_NUMBER_CHANGE_OWNERSHIP,
    CUSTOMER_NUMBER_SERVICE,
    CUSTOMER_NUMBER_PRODUCTS,
    CUSTOMER_NUMBERS_PRODUCTS,
    CUSTOMER_NUMBER_REVISION,
    CUSTOMER_NUMBER_REVISIONS,
    CUSTOMER_NUMBER_BARRING,
    CUSTOMER_NUMBER_CREATE_BARRING,
    CUSTOMER_NUMBER_REMOVE_BARRING,
    CUSTOMER_NUMBER_TECHNOLOGIES,
    CUSTOMER_NUMBER_BILLING,
    CUSTOMER_NUMBER_BILLING_UPDATE,
    CUSTOMER_NUMBER_BILLING_REMOVE,
    CUSTOMER_TOOLBOX_PRODUCTS,
    CUSTOMER_SERVICES,
    CUSTOMER_ENABLE_SERVICE,
    CUSTOMER_DISABLE_SERVICE,
    CUSTOMER_BUNDLES,
    CUSTOMER_BUNDLES_CREATE,
    CUSTOMER_BUNDLE_NUMBERS,
    CUSTOMER_BUNDLE_UPDATE,
    CUSTOMER_TARIFFS,
    CUSTOMER_TARIFF_LEGS,
    CUSTOMER_TARIFF_NUMBERS,
    CUSTOMER_USER_LOGS,
    CUSTOMER_USER_LOG,
    CUSTOMER_ACTIVITIES,
    CUSTOMER_ACTIVITY,
    RECALCULATE_METRICS,
    REALLOCATE_CUSTOMER,
    // CUSTOMER_MFA_LIST,
    // CUSTOMER_CREATE_MFA,
    // CUSTOMER_REMOVE_MFA
}
